module.exports = __webpack_public_path__ + "static/media/est_0001_f.361ba097.jpg";